import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Card, CardBody, CardHeader, CardTitle, Button } from 'reactstrap';

import ConnectorList from './ConnectorList';
import DeleteConfirmModal from './DeleteConfirmModal';

function ConnectorSettings({
  workspace,
  connectors = [],
  isLoading = false,
  onDeleteConnector,
  onTestConnector,
}) {
  const history = useHistory();
  const match = useRouteMatch();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingConnector, setDeletingConnector] = useState(null);
  const [actionLoading, setActionLoading] = useState({
    delete: false,
    test: false,
  });

  const handleCreateNew = () => {
    history.push(`${match.url}/connectors/new`);
  };

  const handleEditClick = (connector) => {
    history.push(`${match.url}/connectors/${connector.id}/edit`);
  };

  const handleDeleteConnector = async (connectorId) => {
    setActionLoading((prev) => ({ ...prev, delete: true }));
    try {
      await onDeleteConnector(connectorId);
      setShowDeleteModal(false);
      setDeletingConnector(null);
    } catch (error) {
      console.error('Failed to delete connector:', error);
    } finally {
      setActionLoading((prev) => ({ ...prev, delete: false }));
    }
  };

  const handleTestConnector = async (connectorId) => {
    setActionLoading((prev) => ({ ...prev, test: true }));
    try {
      await onTestConnector(connectorId);
    } catch (error) {
      console.error('Failed to test connector:', error);
    } finally {
      setActionLoading((prev) => ({ ...prev, test: false }));
    }
  };

  const handleDeleteClick = (connector) => {
    setDeletingConnector(connector);
    setShowDeleteModal(true);
  };

  if (!workspace) {
    return (
      <Card>
        <CardBody>
          <div className="text-center py-4">
            <p className="text-muted">No workspace selected</p>
          </div>
        </CardBody>
      </Card>
    );
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <div className="action-items">
            <Button color="primary" onClick={handleCreateNew}>
              Add Connector
            </Button>
          </div>
          <CardTitle tag="h5">Connectors</CardTitle>
        </CardHeader>
        <CardBody className="pt-0">
          <ConnectorList
            connectors={connectors}
            isLoading={isLoading}
            onEdit={handleEditClick}
            onDelete={handleDeleteClick}
            onTest={handleTestConnector}
            onCreateNew={handleCreateNew}
          />
        </CardBody>
      </Card>

      {/* Delete Confirmation Modal */}
      <DeleteConfirmModal
        isOpen={showDeleteModal}
        toggle={() => {
          setShowDeleteModal(false);
          setDeletingConnector(null);
        }}
        connector={deletingConnector}
        onConfirm={handleDeleteConnector}
        isLoading={actionLoading.delete}
      />
    </div>
  );
}

export default ConnectorSettings;
